import { ReportTypes } from 'lib/store/reportingPlatform/types';

export const FOOD_PURCHASING_ENABLED_BY_ORG = 'food_purchasing_enabled_by_org';
export const RESTAURANT_PAYMENTS_CADENCE_SETTINGS =
  'restaurant_payments_cadence_settings';
export const RS_HOME_ACCESS_LIVE_ORDERS = 'rs_home_access_live_orders';
export const RS_HOME_ACCESS_POS = 'rs_home_access_pos';
export const RS_HOME_BANKING_DETAILS = 'rs_home_banking_details';
export const RS_HOME_CLIENT_ACCESS_UK_POLICIES_PAGE =
  'rs_home_client_access_uk_policies_page';
export const RS_HOME_DELIVERY_AREAS = 'rs_home_delivery_areas';
export const RS_HOME_DELIVERY_AREAS_V2 = 'rs_home_delivery_areas_v2';
export const RS_HOME_DISABLE_LIVE_ORDERS = 'rs_home_disable_live_orders';
export const RS_HOME_ENABLE_LIVE_ORDERS_FOR_HOP =
  'rs_home_enable_live_orders_for_hop';
export const RS_HOME_ENABLE_DINE_IN = 'rs_home_enable_dine_in';
export const RS_HOME_ENABLE_FOH_REPORTS = 'rs_home_enable_foh_reports';
export const RS_HOME_ENABLE_INTERCOM = 'rs_home_enable_intercom';
export const RS_HOME_ENABLE_NRX_PROMPTS = 'rs_home_enable_nrx_prompts';
export const RS_HOME_ENABLE_PUSH_NOTIFICATIONS =
  'rs_home_enable_push_notifications';
export const RS_HOME_ENABLE_REFUND_REPORTS = 'rs_home_enable_refund_reports';
export const RS_HOME_HELP_PAGE = 'rs_home_help_page';
export const RS_HOME_ITEMS_SOLD_EXPORTS = 'rs_home_items_sold_exports';
export const RS_HOME_MANAGER_V2 = 'rs_home_manager_v2';
export const RS_HOME_MARKETER_BLOCKLIST = 'rs_home_marketer_blocklist';
export const RS_HOME_MARKETER_SPONSORED_ADS = 'rs_home_marketer_sponsored_ads';
export const RS_HOME_MARKETER_SPONSORED_ADS_EDIT_ENABLED =
  'rs_home_marketer_sponsored_ads_edit_enabled';
export const RS_HOME_MARKETER_SPONSORED_ADS_SELF_SERVE =
  'rs_home_marketer_sponsored_ads_self_serve';
export const RS_HOME_MARKETER_ADS_BID_RECOMMENDED_RANGE =
  'rs_home_marketer_ads_bid_recommended_range';
export const RS_HOME_MARKETER_REWARDS_SELF_SERVE =
  'rs_home_marketer_rewards_self_serve';
export const RS_HOME_MARKETER_REWARDS_BLOCKLIST =
  'rs_home_marketer_rewards_blocklist';
export const RS_HOME_MARKETER_REWARDS_PAYG_LIVE =
  'rs_home_marketer_rewards_payg_live';
export const RS_HOME_MARKETER_SPONSORED_ADS_AUDIENCE =
  'rs_home_marketer_sponsored_ads_audience';
export const RS_HOME_MARKETER_SUB_NAV = 'rs_home_marketer_sub_nav';
export const RS_HOME_NRX_FEATURE = 'rs_home_nrx_feature';
export const RS_HOME_ORDER_EXPORTS = 'rs_home_order_exports';
export const RS_HOME_RESTAURANT_OPENING_HOURS =
  'rs_home_restaurant_opening_hours';
export const RS_HOME_ROM_PASSWORD_MANAGER = 'rs_home_rom_password_manager';
export const RS_HOME_SHOW_RATINGS = 'rs_home_show_ratings';
export const RS_HOME_TABLE_SERVICE_BANNER = 'rs_home_table_service_banner';
export const RS_HOME_USER_SETTINGS = 'rs_home_user_settings';
export const RS_MARKETER_FULFILLMENT_METHOD_OFFERS =
  'rs_marketer_fulfillment_method_offers';
export const RS_MENUS_SELF_SERVE_ENABLED = 'rs_menus_self_serve_enabled';
export const RS_SETTINGS_QR_CODES = 'rs_settings_qr_codes';
export const WEB_ROM_REQUEST_A_RIDER = 'web_rom_request_a_rider';
export const RS_HOME_EOTHO_BANNER = 'rs_home_eotho_banner';
export const RS_HOME_EOTHO_BANNER_WITH_TS_ENABLED =
  'rs_home_eotho_banner_with_ts_enabled';
export const RS_HOME_QUERY_ACTIVE_OFFER_CAMPAIGNS =
  'rs_home_query_active_offer_campaigns';
export const PAYMENTS_BULK_DOWNLOAD_DOCUMENTS =
  'payments_bulk_download_documents';
export const RS_HOME_BULK_DOWNLOAD_INVOICES =
  'payments_bulk_download_documents';
export const RS_HOME_REVIEW_REPLIES = 'rs_home_review_replies';
export const RS_HOME_METRIC_THRESHOLDS = 'rs_home_metric_thresholds';
export const WEB_ROM_CUSTOMER_LOYALTY_INFO_DISABLED =
  'web_rom_customer_loyalty_info_disabled';
export const RS_HOME_SELF_SERVE_BANKING = 'rs_home_self_serve_banking';
export const RS_HOME_GRANT_REPLY_CREDIT = 'rs_home_grant_reply_credit';
export const RS_SELF_SERVE_ONBOARDING = 'rs_self_serve_onboarding';
export const RS_SELF_SERVE_ONBOARDING_NEW_HYGIENE_RATING_SCREENS =
  'rs_self_serve_onboarding_new_hygiene_rating_screens';
export const RS_SELF_SERVE_ONBOARDING_DAC7 = 'rs_self_serve_onboarding_dac7';
export const RS_CHATBOT = 'rs_chatbot';
export const RS_HOME_SHOW_REVIEWS = 'rs_home_show_reviews';
export const RS_HOME_SETTINGS_BAG_FEES = 'rs_home_settings_bag_fees';
export const RS_HOME_CUSTOMER_CHAMPION = 'rs_home_customer_champion';
export const RS_HOME_CUSTOMER_CHAMPION_BANNER =
  'rs_home_customer_champion_banner';
export const RS_HOME_SHOW_REFUNDS = 'rs_home_show_refunds';

export const RS_HOME_SHOW_COD = 'rs_home_show_cod';

export const RS_MARKETER_PERFORMANCE_GRAPHS = 'rs_marketer_performance_graphs';

export const RS_HOME_DELIVERY_AREAS_V2_RADIUS =
  'rs_home_delivery_areas_v2_radius';

export const RS_HOME_DELIVERY_AREAS_V3_3_MULTI_RADIUS =
  'rs_home_delivery_areas_v3_3_multi_radius';

export const RS_HOME_DISABLE_DELIVERY_AREAS = 'rs_home_disable_delivery_areas';

export const RS_HOME_SHOW_REPORTING_PLATFORM_M3 =
  'rs_home_show_reporting_platform_m3';

export const RS_HOME_MARKETER_MULTIPLE_CAMPAIGNS =
  'rs_home_marketer_multiple_campaigns';

export const RS_INTERNAL_ADMIN_CAMPAIGN_BATCH_AUTO_BIDDING =
  'rs_internal-admin_campaign-batch_auto-bidding';

export const RS_CLIENT_API_RECAPTCHA_ENABLED =
  'rs_client_api_recaptcha_enabled';

export const RS_HOME_MARKETER_UI_ENHANCEMENTS =
  'rs_home_marketer_ui_enhancements';

export const RS_MARKETER_OFFERS_REPORTING = 'rs_marketer_offers_reporting';

export const RS_MARKETER_OFFERS_REPORTING_ROI =
  'rs_marketer_offers_reporting_roi';

export const RS_REPORTING_PLATFORM_SHOW_SCHEDULED_REPORTS =
  'rs_reporting_platform_show_scheduled_reports';

export const RS_HOME_FLEET_SWITCHING_INCLUDE =
  'rs_home_fleet_switching_include';

export const RS_FLEET_SWITCHING_ENABLED = 'rs_fleet_switching_enabled';

export const RS_HOME_ENABLE_REFUND_DISPUTES = 'rs_home_enable_refund_disputes';

export const RS_HOME_ENABLE_REFUND_DISPUTES_NEW_TAG =
  'rs_home_enable_refund_disputes_new_tag';

export const RS_SETTINGS_DAYS_OFF_BULK = 'rs_settings_days_off_bulk';

export const RS_MARKETER_OFFERS_MENU_ITEMS_ENDPOINT =
  'rs_marketer_offers_menu_items_endpoint';
export const RS_HUB_PACKAGING_SERVICE = 'rs_hub_packaging_service';

export const RS_MARKETER_OFFERS_ACCESS_DISABLED =
  'rs_marketer_offers_access_disabled';

export const RS_MARKETER_ADS_ACCESS_DISABLED =
  'rs_marketer_ads_access_disabled';

export const RS_MARKETER_ELIGIBILITY = 'rs_marketer_eligibility';

export const RS_MARKETER_ELIGIBILITY_BY_ORG = 'rs_marketer_eligibility_by_org';
export const RS_INTEGRATIONS_PERFORMANCE = 'rs_integrations_performance';

export const USES_ODC_CLIENTS_API = 'uses_odc_clients_api';

export const RS_MARKETER_METRICS = 'rs_marketer_metrics';

export const RS_MARKETER_OFFERS_MULTI_CAMPAIGNS =
  'rs_marketer_offers_multi_campaigns';

export const RS_SHOW_SHORT_DRN = 'rs_show_short_drn';

export const RS_HUB_ROLES_V2 = 'rs_hub_roles_v2';

export const RS_MARKETER_OFFERS_NEW_CHOOSE_GOAL_UI =
  'rs_marketer_offers_new_choose_goal_ui';

export const RS_HOME_ORDERWEB_DOWNTIME_BANNER =
  'rs_home_orderweb_downtime_banner';

export const RS_MARKETER_OFFERS_NEW_DATE_PICKER =
  'rs_marketer_offers_new_date_picker';

export const RS_HOME_AU_EXIT_BANNER = 'rs_home_au_exit_banner';

export const RS_MARKETER_ADS_BID_GUIDANCE = 'rs_marketer_ads_bid_guidance';

export const RS_HOME_NL_EXIT_BANNER = 'rs_home_nl_exit_banner';

export const RS_REPORTING_PLATFORM_ENABLE_REPORT = (reportType: ReportTypes) =>
  `rs_reporting_platform_enable_report_${reportType}`;

export const RS_REPORTING_PLATFORM_DISABLE_REPORT = (reportType: ReportTypes) =>
  `rs_reporting_platform_disable_report_${reportType}`;

export const RS_REDIRECT_TO_REPORTING_FOR_ORDERS_EXPORT =
  'rs_redirect_to_reporting_for_orders_export';

export const RS_REDIRECT_TO_REPORTING_FOR_ITEMS_SOLD_EXPORT =
  'rs_redirect_to_reporting_for_items_sold_export';

export const RS_MARKETER_ADS_MAINTENANCE = 'rs_marketer_ads_maintenance';

export const RS_SELF_SERVE_ONBOARDING_MAINTENANCE_MODE =
  'rs_self_serve_onboarding_maintenance_mode';

export const RS_MARKETER_ADS_MIN_BID_RECOMMENDATION =
  'rs_marketer_ads_min_bid_recommendation';

export const RS_HUB_SETTINGS_BULK_STATUS_CHANGE =
  'rs_hub_settings_bulk_status_change';

export const RS_MARKETER_ELIGIBILITY_EXCLUSION =
  'rs_marketer_eligibility_exclusion';

export const RS_HUB_SHOW_EDUME_TUTORIALS = 'rs_hub_show_edume_tutorials';

export const RS_HUB_EDUME_TUTORIALS_EXPERIMENT =
  'rs_hub_edume_tutorials_experiment';

export const RS_ENABLE_MEDALLIA_SURVEYS = 'rs_hub_enable_medallia_surveys';

export const RS_MARKETER_OFFERS_AUTO_JOIN_TASTY_THURSDAY =
  'rs_marketer_offers_auto_join_tasty_thursday';

export const WEB_ROM_BROWSER_NOTIFICATIONS_ENABLED =
  'web_rom_browser_notifications_enabled';

export const RS_HUB_OPENING_HOURS_BANNER = 'rs_hub_opening_hours_banner';

export const RS_HOME_ORDER_ACCURACY_CARD = 'rs_home_order_accuracy_card';

export const RS_HOME_SHOW_BOGOF_BANNER = 'rs_home_show_bogof_banner';
